'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function NavLink({ href, children }: { href: string; children: React.ReactNode }) {
  const isActive = usePathname() === href;

  return (
    <Link
      href={href}
      className={`no-underline ${isActive ? 'text-fg/40' : 'text-fg hover:text-fg/40'}`}
    >
      {children}
    </Link>
  );
}
